import { IsString, IsNotEmpty } from 'class-validator';

type SubstitutePeriodType = 'managerAbsence' | 'personal';

export class Substitute {
  @IsString()
  @IsNotEmpty()
  typeOfPeriod: SubstitutePeriodType;

  @IsString()
  @IsNotEmpty()
  dateFrom: string;

  @IsString()
  @IsNotEmpty()
  dateTo: string;
}
